<template>
  <NoCustomerState v-if="!selectedCustomerId" :hasCustomers="hasCustomers" />
  <div v-else>
    <div class="tw-flex tw-flex-row tw-justify-end tw-px-4 tw-items-end tw-mb-4">
      <CustomerActionButton
        v-if="
          currentUser?.user_role.includes('Admin') ||
          currentUser?.user_role.includes('Payment Clearer') ||
          currentUser?.user_role.includes('Approver') ||
          currentUser?.user_role.includes('Payer')
        "
        @click="navigateToCreateSepaPayment"
        class="tw-text-sm tw-font-semibold tw-text-primary-400 tw-underline hover:tw-text-primary-600 tw-transition-colors tw-duration-300"
      >
        {{ t('sepa_payments.titles.new_sepa_payment') }}
      </CustomerActionButton>
    </div>
    <SepaPaymentsFancyTable :customerId="selectedCustomerId" :isDashboard="false" />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import SepaPaymentsFancyTable from '@/views/SepaPayments/Table/SepaPaymentsFancyTable.vue';
import CustomerActionButton from '@/components/shared/CustomerActionButton.vue';
import NoCustomerState from '@/components/shared/NoCustomerState.vue';
import router from '@/router';

import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/user.store';
import { useCustomerStore } from '@/stores/customer.store';
import { useBreadcrumbs } from '@/composables/useBreadcrumbs';

const { currentUser } = storeToRefs(useUserStore());
const { hasCustomers, selectedCustomerId } = storeToRefs(useCustomerStore());

const { t } = useI18n();
const { setBreadcrumbs } = useBreadcrumbs();

const navigateToCreateSepaPayment = () => {
  router.push({ name: 'create-sepa-payments' });
};

onMounted(() => {
  setBreadcrumbs([
    {
      labelKey: 'sidebar.items.sepa',
    },
  ]);
});
</script>
